import { useQuery } from "@tanstack/react-query";

import { authApi } from "@/api/auth";
import { useAuthStore } from "@/stores/auth";

export function useMe() {
  const accessToken = useAuthStore((s) => s.accessToken);
  return useQuery({
    queryKey: ["auth", "me"],
    queryFn: authApi.me,
    enabled: !!accessToken,
    staleTime: 5 * 60_000,
  });
}
